var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      attrs: {
        id: "sidebarRef",
        title: "Ocorrencia nº " + _vm.ocorrencia.id,
        right: "",
        shadow: "",
        width: "80%",
        backdrop: "",
        "backdrop-variant": "white"
      },
      model: {
        value: _vm.localSidebar,
        callback: function($$v) {
          _vm.localSidebar = $$v
        },
        expression: "localSidebar"
      }
    },
    [
      _vm.ocorrencia.id && _vm.localSidebar
        ? _c(
            "b-row",
            { attrs: { "align-h": "center", "align-v": "center" } },
            [
              _c(
                "b-col",
                { staticClass: "col-md-10" },
                [
                  _c(
                    "b-card",
                    [
                      _vm.ocorrencia.id
                        ? _c(
                            "b-card-header",
                            { class: _vm.getClass },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c("h4", [
                                      _c("p", [
                                        _c("b", [
                                          _vm._v(_vm._s(_vm.tipoOcorrencia))
                                        ])
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-2" },
                                [
                                  _c("b-col", [
                                    _c("p", [
                                      _c("b", [
                                        _vm._v(" Código da Ocorrência:")
                                      ]),
                                      _vm._v(" " + _vm._s(_vm.ocorrencia.id))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", [
                                    _c("p", [
                                      _c("b", [_vm._v(" Status:")]),
                                      _vm._v(" " + _vm._s(_vm.getStatus))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "9" } }, [
                                    _c("p", [
                                      _c("b", [_vm._v(" Distribuidor: ")]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.ocorrencia.distribuidor.codigo
                                          ) +
                                          " -\n                " +
                                          _vm._s(
                                            _vm.ocorrencia.distribuidor.nome
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", [
                                    _c("p", [
                                      _c("b", [_vm._v("Classe:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.ocorrencia.distribuidor.classe
                                          )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _vm.ocorrencia.revendedora
                                    ? _c("b-col", { attrs: { cols: "9" } }, [
                                        _c("p", [
                                          _c("b", [_vm._v("Revendedora: ")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.ocorrencia.revendedora
                                                  ? _vm.ocorrencia.revendedora
                                                      .nome
                                                  : ""
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.ocorrencia.enviar_para
                                    ? _c("b-col", [
                                        _c("p", [
                                          _c("b", [_vm._v("Enviar Para:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.ocorrencia.enviar_para)
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { staticClass: "col-md-2" }, [
                                    _c("p", [
                                      _c("b", [_vm._v("Lote:")]),
                                      _vm._v(
                                        " " + _vm._s(_vm.ocorrencia.lote.codigo)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "text-right" }, [
                                    _c("p", [
                                      _c("b", [_vm._v(" Abertura:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatarData(
                                              _vm.ocorrencia.created_at
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "text-right" }, [
                                    _c("p", [
                                      _c("b", [_vm._v(" Última Atualização:")]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formatarData(
                                              _vm.ocorrencia.updated_at
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-3" },
                                [
                                  _c("b-col", [
                                    _c("b", [_vm._v(" Arquivos de Lote ")])
                                  ]),
                                  _vm._v(" "),
                                  _vm.ocorrencia && _vm.ocorrencia.analista
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right",
                                          attrs: { cols: "8" }
                                        },
                                        [
                                          _c("small", [
                                            _c("b", [
                                              _vm._v("Analista Responsável: ")
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.ocorrencia.analista.name
                                                ) +
                                                " "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _vm.ocorrencia.lote.url_extrato
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-info btn-sm mr-3",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Fatura por Revendedora"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getUrl(
                                                  _vm.ocorrencia.lote
                                                    .url_extrato
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-list-ol"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.ocorrencia.lote.url_resumo
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm mr-3",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Resumo de Pedido"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getUrl(
                                                  _vm.ocorrencia.lote.url_resumo
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-file-alt"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.ocorrencia.lote.url_nfe
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-warning btn-sm mr-3",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Nota Fiscal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getUrl(
                                                  _vm.ocorrencia.lote.url_nfe
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-file-pdf"
                                            })
                                          ]
                                        )
                                      : _vm.ocorrencia.lote.has_notas &&
                                        _vm.ocorrencia.lote.has_notas.length > 0
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-warning btn-sm mr-3",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Nota Fiscal"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.viewNota(
                                                  _vm.ocorrencia.lote.codigo,
                                                  "nota"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-file-pdf"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.ocorrencia.lote.url_devolve
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm mr-3",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "tooltip",
                                              "data-placement": "top",
                                              title: "Devolução"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.getUrl(
                                                  _vm.ocorrencia.lote
                                                    .url_devolve
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-car"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.ocorrencia && _vm.ocorrencia.valor_max
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("small", [
                                            _c("b", [
                                              _vm._v("Reembolso máximo: ")
                                            ])
                                          ]),
                                          _c(
                                            "small",
                                            { staticStyle: { color: "red" } },
                                            [
                                              _vm._v(
                                                " R$ " +
                                                  _vm._s(
                                                    _vm.ocorrencia.valor_max
                                                      .toString()
                                                      .replace(".", ",")
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _vm.ocorrencia.id
                            ? _c("v-mensagens", {
                                staticClass: "mt-3",
                                attrs: { ocorrenciaProps: _vm.ocorrencia },
                                on: { loadOcorrencias: _vm.loadOcorrencias }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-666eff12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666eff12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/MensagensBar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-666eff12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/MensagensBar.vue
// module chunks = 2